//////////////////////////////////////
// M021 video modul
var _videoPlayers = [];

function initVideoModul() {

    if ($(".videoModuleVideo").length > 0) {

		//init youtube script
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		$("body").prepend(tag);

		var playerPos = 0;
        $(".videoModuleVideo").each(function () {			
			//save quiz pos in data attr
			$(this).attr("data-player-pos", playerPos);
			playerPos++;

        });
    }

}
function onVideoPlayerReady(event) {
	var $q = getVideoEventPlayer(event.target);	
	$q.find(".videoModuleVideo__loader").hide();
}
function onVideoPlayerError(event) {
	//console.log("PAN onVideoPlayerError()");
}

function onVideoPlayerStateChange(event) {
	
	var $p = getVideoEventPlayer(event.target);

	//handle events
	switch (event.data) {
		case YT.PlayerState.PLAYING:
			break;
		case YT.PlayerState.PAUSED:
			break;
		case YT.PlayerState.BUFFERING:
			break;
		case YT.PlayerState.CUED:
			break;
		case YT.PlayerState.ENDED:
			break;
		default:
			break;
	}
}

function getVideoEventPlayer(player){
	//get player pos
	var playerPos = 0;
	for (var i = 0; i < _videoPlayers.length; i++) {
		var p = _videoPlayers[i];
		if(p == player){
			playerPos = i;
		}
	}

	//get quiz object
	$(".videoModuleVideo").removeClass("active");
	var $p = $(".videoModuleVideo").first();
	$(".videoModuleVideo").each(function(){
		if($(this).attr("data-player-pos") == playerPos){
			$p = $(this);
		}
	});

	return $p;
}

function handleVideoPlayerYoutubeReadyEvent(){
	$(".videoModuleVideo").each(function(){
		$(this).find(".videoModuleVideo__loader").hide();
		
		var playerId = $(this).find(".videoModuleVideo__video-player").attr("id");
		var youtubeVideoId = $(this).find(".videoModuleVideo__video-player").attr("data-video-id");

		var videoPlayer = new YT.Player(playerId, {
			height: '360',
			width: '640',
			videoId: youtubeVideoId,
			playerVars: {
				"autoplay": 0,
				"controls": 1,
				"modestbranding": 1,
				"rel": 1
			},
			events: {
				'onReady': onVideoPlayerReady,
				'onStateChange': onVideoPlayerStateChange,
				'onError': onVideoPlayerError
			}
		});
		_videoPlayers.push(videoPlayer);
	});
}